import { businessTimeAdd } from '@xbcb/js-utils';
import moment from 'moment';

export const getBusinessHourDeadline = (sla: number): string => {
  return businessTimeAdd(moment.utc(Date.now()), sla).toISOString();
};
